<app-yes-no-message-dialog
  [title]="kuendigungDialogTitle()"
  [message]="kuendigungDialogMessage()"
  [data]="zaehler()"
  okButton="Ja, kündigen"
  cancelButton="Abbrechen"
  [isOpen]="kuendigungDialogOpen()"
  (closed)="onKundigungDialogClosed($event)">
</app-yes-no-message-dialog>

<div class="rounded-lg bg-white shadow hover:shadow-md transition-shadow border border-gray-100">
  <!-- Card Header mit Status -->
  <div [class]="'rounded-t-lg px-4 py-3 border-b border-gray-100 ' + getStatusClass(zaehler().genehmigt)">
    <div class="flex items-center justify-between gap-2">
      <div class="flex items-center gap-2 flex-1 min-w-0">
        <fa-icon
          [icon]="getStatusIcon(zaehler().genehmigt)"
          [class]="'text-' + (zaehler().genehmigt === true ? 'green' : zaehler().genehmigt === false ? 'red' : 'blue') + '-600'"
          aria-hidden="true">
        </fa-icon>
        <span class="text-sm font-medium text-gray-800 truncate">{{ getStatusLabel(zaehler().genehmigt) }}</span>
      </div>
      <span [class]="'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium whitespace-nowrap ' + getStatusBadgeClass(zaehler().genehmigt)">
        {{ zaehler().zaehlernummer }}
      </span>

      <div class="relative shrink-0" data-actions-menu-container>
        <button
          type="button"
          class="inline-flex items-center justify-center w-10 h-10 rounded-full bg-transparent text-gray-500 hover:bg-gray-100 hover:text-gray-700 transition-colors"
          aria-label="Aktionen"
          aria-haspopup="menu"
          [attr.aria-expanded]="actionsMenuOpen()"
          aria-controls="zaehler-actions-menu"
          (click)="toggleActionsMenu()">
          <fa-icon [icon]="faEllipsisVertical" aria-hidden="true"></fa-icon>
        </button>

        @if (actionsMenuOpen()) {
          <div
            id="zaehler-actions-menu"
            role="menu"
            class="absolute right-0 top-11 z-10 min-w-40 rounded-lg border border-gray-200 bg-white p-1 shadow-lg"
          >
            <button
              type="button"
              role="menuitem"
              class="inline-flex w-full items-center justify-between rounded-md px-3 py-2 text-left text-sm text-red-700 hover:bg-red-50"
              (click)="onMenuKundigen()">
              <span>Kündigen</span>
              <fa-icon [icon]="faTrash" aria-hidden="true"></fa-icon>
            </button>
          </div>
        }
      </div>
    </div>
  </div>

  <!-- Card Content -->
  <div class="px-4 py-4 space-y-3">
    <!-- Zählernummer -->
    <div>
      <p class="text-xs font-semibold text-gray-500 uppercase">Einbauort</p>
      <p class="text-sm text-gray-800 mt-1 font-mono break-all">{{ zaehler().ort || '—' }}</p>
    </div>

    <div>
      <p class="text-xs font-semibold text-gray-500 uppercase">Einbaudatum</p>
      <p class="text-sm text-gray-800 mt-1 font-mono break-all">{{ zaehler().einbaudatum | dateTimeFromIso | dateTimeToFormat:'dd. MMMM yyyy' }}</p>
    </div>

    <div>
      <p class="text-xs font-semibold text-gray-500 uppercase">Eichdatum</p>
      <p class="text-sm text-gray-800 mt-1 font-mono break-all">{{ zaehler().eichdatum | dateTimeFromIso | dateTimeToFormat:'dd. MMMM yyyy' }}</p>
    </div>

    <div>
      <p class="text-xs font-semibold text-gray-500 uppercase">Nächste Eichung</p>
      <p class="text-sm text-gray-800 mt-1 font-mono break-all">{{ zaehler().naechsteEichung | dateTimeFromIso | dateTimeToFormat:'dd. MMMM yyyy' }}</p>
    </div>
  </div>

  <hr class="border-gray-200" />

  <div class="px-4 py-4 space-y-3 bg-gray-50">
    <!--<p class="text-xs font-semibold text-blue-600 uppercase tracking-wide">Ablesung</p>-->
    <div>
      <p class="text-xs font-semibold text-gray-500 uppercase">Letzter Zählerstand</p>
      <p class="text-sm text-gray-800 mt-1 font-mono break-all">{{ zaehler().letzterZaehlerstand !== null ? zaehler().letzterZaehlerstand : '—' }}</p>
    </div>

    <div>
      <p class="text-xs font-semibold text-gray-500 uppercase">Datum des letzten Zählerstands</p>
      <p class="text-sm text-gray-800 mt-1 font-mono break-all">{{ zaehler().letzterZaehlerstandDatum ? (zaehler().letzterZaehlerstandDatum | dateTimeFromIso | dateTimeToFormat:'dd. MMMM yyyy') : '—' }}</p>
    </div>

    <div class="flex items-center justify-center gap-2">
      <button
        class="button-primary inline-flex items-center justify-center gap-2"
        (click)="onAblesungEintragen(zaehler().id)">
        Neue Ablesung eintragen
      </button>
    </div>

  </div>
</div>
